import { InvoiceVerificationDTO, MessageV2DTO } from 'support/types';

import { GenerateDiscrepancyEmail } from './GenerateDiscrepancyEmail/GenerateDiscrepancyEmail';

export const InvoiceVerificationActions = ({
  invoice,
  invoiceVerification,
}: {
  invoice: MessageV2DTO;
  invoiceVerification: InvoiceVerificationDTO;
}) => {
  return (
    <>
      <GenerateDiscrepancyEmail invoice={invoice} invoiceVerification={invoiceVerification} />
    </>
  );
};
